import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "woa-link",
    templateUrl: "./link.component.html",
})
export class LinkComponent {
    @Input() label: string;
    @Input() link: string;
    @Input() postscript: string;
    @Input() translationParams: any = {};
    @Input() underlined: boolean = true;
    @Input() disabled: boolean = false;
    @Input() negative: boolean = false;
    @Input() plain: boolean = false;

    @Output() onActivate: EventEmitter<void> = new EventEmitter();

    activate(event: Event): void {
        event.stopPropagation();
        this.onActivate.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/buttons/link/link.component.ts